export const portfolioTypeIds = {
    MAIN: 1,
    VIRTUAL: 2,
    SLICE: 3,
};
